"use strict";
exports.__esModule = true;
exports.currLocation = void 0;
var currLocation = function () { return ({
    pathname: window.location.pathname,
    search: window.location.search
}); };
exports.currLocation = currLocation;
